import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectInfo } from '../model/project.model';
import { LookupInfo } from '../model/lookup.model';
import { Observable, Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  HttpClient,
  HttpHeaders,

  HttpEventType
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyInfo } from '../model/company.model';
import { TokenService } from '../service/token.service';
import { GlobalService } from '../service/global.service';
import { EmpInfo } from '../model/emp.model';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { RoleInfo } from '../model/role.model';
import { SimpleTextInfo } from '../model/simpleTextInfo.model';
import { Button } from 'protractor';
import { ProfitLossReportDialogComponent } from '../dialogs/profit-loss-report-dialog.component';
import { MatDialog } from '@angular/material/dialog';

let today = new Date().toISOString()



@Component({
  selector: 'app-project-axis',
  templateUrl: './project-axis.component.html',
  styleUrls: ['./project-axis.component.css']
})

export class ProjectAxisComponent implements OnInit {

  ProjectManagementForm: FormGroup
  // ------------------------------- Assign Manager Zone -----------------------------------------------
  AssignPMForm: FormGroup
  AssignPMList: EmpInfo[] = [];
  AssignRoleList: RoleInfo[] = [];
  cuurentselectProjectAssignPM: string = null
  ddlAssignPM: string

  // ------------------------------- Assign Manager Zone -----------------------------------------------

  subscriptionLoadProjectList: Subscription
  subscriptionCountProjectList: Subscription
  public body: string;

  ProjectPromise: Promise<ProjectInfo[]>
  ProjectList: ProjectInfo[] = [];
  ProjectStatusList: LookupInfo[] = [];
  ProjectSubTypeList: LookupInfo[] = [];
  CompanyList: CompanyInfo[] = [];
  projectInfo: ProjectInfo = new ProjectInfo;



  txtSearchProjectCode: string
  txtSearchProjectName: string
  isSearchSubmitted: boolean = false;
  
  
  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;

  filesToUpload: File[] = [];
  RoleCode: string;

  resultUploadfile: any;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;

  //Pagination variable
  public currentPageNumber: number
  public ProjectTotal: number
  public totalPages: number
  public environment: number


  _ForK2: string;
  _EmpCode: string;
  _EmpRoleCode: string;
  _UserName: string;
  _RoleCode: string;

  //empselect
  employeeselectrun: boolean = false;
  selectedemp: EmpInfo;

  projectselectrun: boolean = false;
  selectedproject: ProjectInfo[] = [];

  AvailableSubProjectCode: SimpleTextInfo;
  ProjectCodeBak: string;

  //theme
  ButtonColor: string = "btn-gold";
  TableColor: string = "table-stand-gold";
  ModalColor: string = "bg-gold";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private router: Router, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService, private formBuilder: FormBuilder,private dialog: MatDialog) {
    this.baseurl = environment.base_api;

    // this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    // this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    // this._UserName = this.activatedRoute.snapshot.params.UserName;
    // this._EmpRoleCode = this.activatedRoute.snapshot.params.EmpRoleCode;
    GlobalService.CheckPagingAccessRights();
  }


  async ngOnInit() {

    // create control
    this.ProjectManagementForm = this.formBuilder.group({

    });


    //Initial pagination info
    this.currentPageNumber = 1;
    this.environment = environment.PageSize;


    //Initial general data
    this._RoleCode = !!this._EmpRoleCode ? this._EmpRoleCode : localStorage.getItem("EmpRoleCode");
    this._EmpCode = !!this._EmpCode ? this._EmpCode : localStorage.getItem("EmpCode");
    this._UserName = !!this._UserName ? this._UserName : localStorage.getItem("UserName");

    //Set Theme
    if (this._RoleCode == 'DIRECTOR' || this._RoleCode == 'SALEDIRECTOR' || this._RoleCode == 'PROJDIRECTOR' || this._RoleCode == 'MANAGER') {
      this.ButtonColor = "btn-primary";
      this.TableColor = "table-stand-greenlight"
      this.ModalColor = "";
    }


    this.resultUploadfile = { type: null };
   
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProject(auth_token);
      this.OnLoadCountProjectList(auth_token);

    }

    this.txtSearchProjectCode = ""
    this.txtSearchProjectName = ""

  


  }

  ///////////////////////////////////////Events////////////////////////////////////////////
  async btnClick_showProjectList() {
    this.currentPageNumber = 1;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {

      this.LoadProject(auth_token);
      this.OnLoadCountProjectList(auth_token);
    }

  }
  
  
  openReport(code: string): void {
    console.log('Open P/L for', code);   
    this.dialog.open(ProfitLossReportDialogComponent, {
      panelClass: ['full-screen-dialog', 'pl-wide-100'],      
      disableClose: true,   
      data: { projectCode: code }
    });
  }
  ///////////////////////////////////////Functions/////////////////////////////////////////



  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  LoadProject(auth_token) {
    this.subscriptionLoadProjectList = this.LoadProjectList(auth_token)
      .subscribe(
        data => {
          this.subscriptionLoadProjectList.unsubscribe();
          this.ProjectList = data.sort((a, b) => {
            return new Date(b.CreateDate).getTime() - new Date(a.CreateDate).getTime();
          });

          console.log("TEST")
          console.log(data)

          this.hidcouchk = this.ProjectList.length.toString();
          if (data.length == 0 && this.txtSearchProjectName == "" && this.txtSearchProjectCode == "" && this._RoleCode != "ADMIN") {
            if (!!this._ForK2 && this._ForK2 == 'Y') {
              if (!!this._EmpCode && !!this._UserName) {
                localStorage.setItem("EmpCode", this._EmpCode);
                localStorage.setItem("UserName", this._UserName);
                localStorage.setItem("EmpRoleCode", this._RoleCode);
              }
            }

            this.router.navigate(['project-detail'], { queryParams: { ProjectCode: data[0].ProjectCode } })

          }



        },
        err => {
          console.error('Observer got an error: ' + err)
        },
        () => {
          console.log('Observer got a complete notification')
        }

      )
  }

  async LoadMasterProjectList(dataId: number = 0): Promise<ProjectInfo[]> {
    var pathapi = "";
    var UserName = this._UserName;
    var FilterByEmpCode: boolean = true;
    if (this._RoleCode == "MANAGER" || this._RoleCode == "PROJECTCO" || this._RoleCode == "DIRECTOR" || this._RoleCode == "SALEDIRECTOR" || this._RoleCode == "PROJDIRECTOR" || this._RoleCode == "HRMANAGER") {
      pathapi = "Project/GetProjectCriteria";
      if (this._RoleCode != "MANAGER" && this._RoleCode != "HRMANAGER") FilterByEmpCode = false;
    } else {
      pathapi = "Project/GetProjectbyMemberCriteria";

    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = ((this.currentPageNumber > 0 ? this.currentPageNumber : 1) - 1) * environment.PageSize;

      let data = {};
      data['ProjectId'] = dataId;
      data["ProjectCode"] = this.checkUndefinedString(this.txtSearchProjectCode);
      data["ProjectName"] = this.checkUndefinedString(this.txtSearchProjectName);
      if (FilterByEmpCode) data["EmpCode"] = this.checkUndefinedString(this._EmpCode);
      data["UserName"] = this.checkUndefinedString(UserName);
      data["rowFetch"] = environment.PageSize;
      data["rowOFFSet"] = offset;
      data["FlagDelete"] = "N";
      let strjson = JSON.stringify(data);

      return this.httpClient
        .post<ProjectInfo[]>(this.baseurl + pathapi,
          strjson, httpOptions).toPromise()
    }
  }

  LoadProjectList(auth_token): Observable<ProjectInfo[]> {
    var pathapi = "";
    var UserName = this._UserName;
    var FilterByEmpCode: boolean = true;
    // if (this._RoleCode == "MANAGER" || this._RoleCode == "PROJECTCO" || this._RoleCode == "DIRECTOR" || this._RoleCode == "SALEDIRECTOR" || this._RoleCode == "PROJDIRECTOR" || this._RoleCode == "HRMANAGER") {
    pathapi = "Project/GetProjectCriteriaReport";
    // if (this._RoleCode != "MANAGER" && this._RoleCode != "PROJECTCO" && this._RoleCode != "HRMANAGER") FilterByEmpCode = false;
    // } else {
    //   pathapi = "Project/GetProjectbyMemberCriteria";

    // }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = ((this.currentPageNumber > 0 ? this.currentPageNumber : 1) - 1) * environment.PageSize;

    let data = {};
    data["ProjectCode"] = this.checkUndefinedString(this.txtSearchProjectCode);
    data["ProjectName"] = this.checkUndefinedString(this.txtSearchProjectName);
    if (FilterByEmpCode) data["EmpCode"] = this.checkUndefinedString(this._EmpCode);
    data["UserName"] = this.checkUndefinedString(UserName);
    data["rowFetch"] = environment.PageSize;
    data["rowOFFSet"] = offset;
    data["FlagDelete"] = "N";
    let strjson = JSON.stringify(data);

    return this.httpClient
      .post<ProjectInfo[]>(this.baseurl + pathapi,
        strjson, httpOptions)

  }


  LoadCountProjectList(auth_token) {

    var pathapi = "";
    var FilterByEmpCode: boolean = true;
    // if (this._RoleCode == "MANAGER" || this._RoleCode == "DIRECTOR" || this._RoleCode == "SALEDIRECTOR" || this._RoleCode == "PROJDIRECTOR" || this._RoleCode == "PROJECTCO" || this._RoleCode == "HRMANAGER") {
    pathapi = "Project/GetCountProjectCriteriaReport";
    // if (this._RoleCode != "MANAGER" && this._RoleCode != "PROJECTCO" && this._RoleCode != "HRMANAGER") FilterByEmpCode = false;
    // } else {
    //   pathapi = "Project/GetCountProjectbyMemberCriteria";

    // }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };


    let data = {};
    data["ProjectCode"] = this.checkUndefinedString(this.txtSearchProjectCode);
    data["ProjectName"] = this.checkUndefinedString(this.txtSearchProjectName);
    if (FilterByEmpCode) data["EmpCode"] = this.checkUndefinedString(this._EmpCode);

    data["FlagDelete"] = "N";
    let strjson = JSON.stringify(data);

    return this.httpClient
      .post<number>(this.baseurl + pathapi,
        strjson, httpOptions)
      .toPromise()
  }




  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }



  async clearSearchSection() {

    this.txtSearchProjectCode = "";
    this.txtSearchProjectName = "";
    this.currentPageNumber = 1;

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProject(auth_token);
      this.OnLoadCountProjectList(auth_token);
    }
  }

  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  async OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadProject(auth_token);
      }
    }

  }

  OnLoadCountProjectList(auth_token) {
    //call function load count all ticket list on hand current role user
    this.LoadCountProjectList(auth_token).then(data => {
      this.ProjectTotal = data;
      if (this.ProjectTotal == 0) {
        this.currentPageNumber = 0;
      }
      this.totalPages = Math.ceil(this.ProjectTotal / environment.PageSize);
    });
  }


  selectedEmp(event) {
    console.log("SELECTED EMP")

    this.selectedemp = event[0];
    console.log(this.selectedemp)


  }
  


}


